import {css} from 'emotion'
import {SubtitlePage} from './..'
import { Link } from './..'
import { Colors } from '../core';

export const TheftsStyle = css({
  '.theft': {
    '&-container': {
      margin: '4rem auto',
      width: '100%',
      maxWidth: 1000,
      'h2': {
        textAlign: 'center',
        ...SubtitlePage,
        textTransform: 'uppercase',
        fontWeight: 800,
        marginBottom: '4rem'
      },
    },
    '&-select, &-ref':{
      maxWidth: '100%',
      flexBasis: '100%',
      marginBottom: '1rem',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(50% - 50px)',
        flexBasis: 'calc(50% - 50px)',
        marginBottom: 0
      }
    },
    '&-submit': {
      width: '100%',
      textAlign: 'right',
      
      '@media (min-width: 1024px)': {
        width: '100px',
        alignSelf: 'center',
        textAlign: 'center',
      },
      'button': {
        background: 'none',
        ...Link,
        border: 0,
        cursor: 'pointer',
        padding: '1rem',
        '@media (min-width: 1024px)': {
          padding: 0,
          marginRight: '1rem',
        }
      }
    },
    
    '&-select': {
      '@media (min-width: 1024px)': {
        paddingRight: '2rem',
      },
    },
    '&-ref': {
      '@media (min-width: 1024px)': {
        paddingLeft: '2rem',
      }
    },
  },
  'form': {
    width: '100%',
    marginBottom: '4rem',
  },
  '.theft-result__loader': {
    textAlign: 'center',
  },
  '.error': {
    textAlign: 'center'
  }
})

export const TheftSoloStyle = css({
  '.theft-form': {
    maxWidth: '900px',
    margin: '4rem auto',
    '.form-field': {
      marginBottom: '1rem'
    }
  },
  '.content-loader': {
    textAlign: 'center'
  },
})


// WEBPACK FOOTER //
// ./src/styles/containers/theft.js